import { useEffect, useState } from 'react';

import { getAgentClients, serializeAgentClient } from '../api';
import { B2BClient } from '../clients/types';

export type ClientsByEmailState = 'idle' | 'loading' | 'done' | 'error';

// Клиенты агентства с почтой из заявки. Поиск по клиентам полнотекстовый (имя, телефон, почта),
// поэтому оставляем только точное совпадение почты — подтверждённой или ждущей подтверждения.
export const useClientsByEmail = (email: string | null | undefined) => {
  const [clients, setClients] = useState<B2BClient[]>([]);
  const [state, setState] = useState<ClientsByEmailState>('idle');

  useEffect(() => {
    const normalizedEmail = (email || '').trim().toLowerCase();
    setClients([]);

    if (!normalizedEmail) {
      setState('idle');
      return undefined;
    }

    let isActive = true;
    setState('loading');

    getAgentClients({ query: normalizedEmail })
      .then(({ clients: found }) => {
        if (!isActive) return;

        setClients(
          found
            .filter((client) =>
              [client.email, client.unconfirmed_email].some(
                (value) => (value || '').toLowerCase() === normalizedEmail
              )
            )
            .map((client) => serializeAgentClient(client))
        );
        setState('done');
      })
      .catch(() => {
        if (isActive) setState('error');
      });

    return () => {
      isActive = false;
    };
  }, [email]);

  return { clients, state };
};
